import React from 'react';
import { Text } from 'Components/frameworks/text/Text';
import { Title } from 'Components/frameworks/title/Title';
type Props = {
  infos: Array<{
    items?: Array<string>;
    text?: string;
    title: string;
  }>;
};
export const TourInformation = ({ infos }: Props) => (
  <div className="grid grid-cols-1 gap-20 sm:grid-cols-2">
    {infos.map(({ items, text, title }) => (
      <div key={title}>
        <Title className="mb-10" theme="title-brand-n2">
          {title}
        </Title>
        {items && (
          <ul className="text-14 leading-normal text-black">
            {items.map((item) => (
              <li className="list-disc py-5" key={item}>
                {item}
              </li>
            ))}
          </ul>
        )}
        {text && <Text text={text} />}
      </div>
    ))}
  </div>
);
